import * as React from 'react';
import { IPaymentsAction } from '../payments-interfaces';
import { paymentsActionTypes } from '../payments-action-types';
import axios from 'axios';
import { BASE_URL } from '../../../../config/environmentConfig';
import { requestErrorHandler } from '../../../utils/newApplicationUtils';
import {
  getFormattedPartnerBankFormFields,
  PartnerBankFieldsReturnTypes,
} from '../../../constants/new-partner/partner-bank-form';

interface IPartnerBankDetails {
  dispatch: React.Dispatch<IPaymentsAction>;
  financialAccountId: string;
}

export const fetchPartnerBankDetails = async ({ dispatch, financialAccountId }: IPartnerBankDetails): Promise<void> => {
  try {
    dispatch({ type: paymentsActionTypes.SET_FETCH_PARTNER_BANK_LOADING, payload: true });
    const res = await axios.get(`${BASE_URL.PAYMENTS}/FinancialAccounts/${financialAccountId}`);
    dispatch({ type: paymentsActionTypes.FETCH_PARTNER_BANK, payload: res?.data ?? null });
  } catch (e) {
    dispatch({ type: paymentsActionTypes.FETCH_PARTNER_BANK, payload: null });
    console.log('setPartnerBankDetails', e);
    requestErrorHandler(e);
  }
};

export const setPartnerBankVerification = async ({ dispatch, financialAccountId }: IPartnerBankDetails): Promise<void> => {
  try {
    dispatch({ type: paymentsActionTypes.SET_PARTNER_BANK_VERIFICATION_LOADING, payload: true });
    await axios.post(`${BASE_URL.PAYMENTS}/FinancialAccounts/verify-account`, {
      id: financialAccountId
    });
    await fetchPartnerBankDetails({ dispatch, financialAccountId });
    dispatch({ type: paymentsActionTypes.SET_PARTNER_BANK_VERIFICATION_LOADING, payload: false });
  } catch (e) {
    console.log('setPartnerBankVerification', e);
    dispatch({ type: paymentsActionTypes.SET_PARTNER_BANK_VERIFICATION_LOADING, payload: false });
    requestErrorHandler(e);
  }
};

export const setToDefaultPartnerBankDetails = (dispatch: React.Dispatch<IPaymentsAction>): void => {
  dispatch({ type: paymentsActionTypes.FETCH_PARTNER_BANK, payload: null });
};

interface ISetPartnerBankDetails {
  formik: any;
  pid: string;
}

export const setPartnerBankDetails = async ({ formik, pid }: ISetPartnerBankDetails): Promise<void> => {
  const data: PartnerBankFieldsReturnTypes = getFormattedPartnerBankFormFields(formik.values);
  data.relatedEntityId = pid;
  await axios.post(`${BASE_URL.PAYMENTS}/FinancialAccounts`, data);
};

interface IChangePartnerBankDetails {
  formik: any;
  financialAccountId: string;
}
export const changePartnerBankDetails = async ({ formik, financialAccountId }: IChangePartnerBankDetails): Promise<void> => {
  const data: PartnerBankFieldsReturnTypes = getFormattedPartnerBankFormFields(formik.values);
  delete data.relatedEntityType;
  await axios.put(`${BASE_URL.PAYMENTS}/FinancialAccounts/${financialAccountId}`, data);

};